import { render, staticRenderFns } from "./ShutterBulk.vue?vue&type=template&id=38c0e291&"
import script from "./ShutterBulk.vue?vue&type=script&lang=js&"
export * from "./ShutterBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports